// Import types from feature types
import type { FinancialStatementsFilterKeys } from '../types'
// BudgetFilters type for mutation hooks
export interface BudgetFilters {
  budgetingScenario?: string
  period?: string
  accountCode?: string
  incomeStatementRowId?: string
  dimensionId?: string
}

// Object-based query key factory
export const financialStatementsKeys = {
  // Base scope
  all: [{ scope: 'financialStatements' }] as const,
  // Statement data queries
  statements: () => [{ ...financialStatementsKeys.all[0], entity: 'statements' }] as const,
  statementData: (filters: FinancialStatementsFilterKeys) =>
    [{ ...financialStatementsKeys.statements()[0], ...filters }] as const,
  // Comments queries
  comments: () => [{ ...financialStatementsKeys.all[0], entity: 'comments' }] as const,
  commentsData: (params: { companyId: string; budgetingScenarioId?: number | null }) =>
    [
      {
        ...financialStatementsKeys.comments()[0],
        companyId: params.companyId,
        budgetingScenarioId: params.budgetingScenarioId
      }
    ] as const
}
